import React from "react";
import styles from "./RedirectCircleView.module.css";
import AssetsPack from "../util/AssetsPack";
import ImageComponent from "./ImageComponent";
import clsx from "clsx";

interface RedirectCircleView {
  onClick?: () => void;
  className?: string;
  isHovered?: boolean;
}

const RedirectCircleView: React.FC<RedirectCircleView> = ({
  onClick,
  className,
  isHovered,
}) => {
  return (
    <div
      className={clsx(styles["card-gametype-redirect"], className)}
      onClick={onClick}
    >
      <ImageComponent
        src={AssetsPack.icons.REDIRECT_ARROW.default}
        className={clsx(
          styles["card-gametype-image"],
          isHovered && styles["icon-spin"]
        )}
      />
    </div>
  );
};

export default RedirectCircleView;
